export class BasePlatform {
    constructor() {
        if (this.constructor === BasePlatform) {
            throw new Error('BasePlatform 不能直接实例化');
        }
    }

    _throwNotImplemented(methodName) {
        throw new Error(`必须实现 ${methodName} 方法`);
    }

    // 存储相关
    async saveData(_key, _value) {
        this._throwNotImplemented('saveData');
    }

    async getData(_key) {
        this._throwNotImplemented('getData');
    }

    async removeData(_key) {
        this._throwNotImplemented('removeData');
    }

    // 图片处理相关
    async getImageData(_source) {
        this._throwNotImplemented('getImageData');
    }

    // 环境信息
    getPlatformInfo() {
        this._throwNotImplemented('getPlatformInfo');
    }

    // 路由相关
    navigate(_path) {
        this._throwNotImplemented('navigate');
    }
}